import store from "../../../../../../store";
import { iconPlusGreen, iconPlusBlue, iconPlusBlack } from "../../../../assetsSQFT";
import $ from "jquery";

class CanvasCursor {
  constructor() {
    this.cursorImages = new Map();
    this.currentCursorImage = null;
    this.currentPosition = { x: 0, y: 0 };
  }

  updatePosition(mousePos) {
    this.currentPosition = { x: mousePos.x, y: mousePos.y };
  }

  // Load cursor image for specific tool type
  loadCursorImage(toolType, feature) {
    const cacheKey = this.getCacheKey(toolType, feature);

    if (this.cursorImages.has(cacheKey)) {
      this.currentCursorImage = this.cursorImages.get(cacheKey);
      return;
    }

    const domImg = document.createElement('img');
    domImg.crossOrigin = "Anonymous";

    const $img = $(domImg);
    $img.css({
      position: 'absolute',
      width: '1px',
      height: '1px'
    });

    const imgOnLoad = () => {
      const bounds = 18;
      let imgWidth = bounds;
      let imgHeight = bounds;

      const ratio = domImg.naturalHeight / domImg.naturalWidth;
      if (domImg.naturalWidth > domImg.naturalHeight) {
        imgHeight = bounds * ratio;
      } else {
        imgWidth = bounds * ratio;
      }

      const cursorImageData = {
        image: domImg,
        width: imgWidth,
        height: imgHeight
      };

      this.cursorImages.set(cacheKey, cursorImageData);
      this.currentCursorImage = cursorImageData;
    };

    $img.on('load', imgOnLoad);
    $img.on('error', () => {
      this.currentCursorImage = { image: null, width: 18, height: 18 };
    });

    $img.appendTo($('body'));
    $img.attr('src', this.getCursorImageSrc(toolType, feature));
  }

  getCacheKey(toolType, feature) {
    if (toolType === 'backsplash' && feature.size === "wall") {
      return 'wall';
    }
    return toolType;
  }

  getCursorImageSrc(toolType, feature) {
    if (toolType === 'edge') {
      return iconPlusGreen;
    } else if (toolType === 'backsplash') {
      return feature.size === "wall" ? iconPlusBlack : iconPlusBlue;
    } else {
      return iconPlusBlue;
    }
  }

  updateCursor() {
    const state = store.getState();
    const resourceState = state.sqftResourceState;

    if (resourceState.activeTool && resourceState.currentFeature) {
      this.loadCursorImage(resourceState.activeTool, resourceState.currentFeature);
    }
  }

  render(ctx) {
    if ($(window).width() <= 768) return;

    const state = store.getState();
    const resourceState = state.sqftResourceState;

    if (!resourceState.cursorVisible || !resourceState.toolReady || !this.currentCursorImage) {
      return;
    }

    if (this.currentCursorImage.image) {
      ctx.drawImage(
        this.currentCursorImage.image,
        this.currentPosition.x + 10,
        this.currentPosition.y + 10,
        this.currentCursorImage.width,
        this.currentCursorImage.height
      );
    }
  }

  isVisible() {
    const state = store.getState();
    const resourceState = state.sqftResourceState;
    return resourceState.cursorVisible && resourceState.toolReady && this.currentCursorImage;
  }

  getPosition() {
    return this.currentPosition;
  }

  clearCursor() {
    this.currentCursorImage = null;
    this.currentPosition = { x: 0, y: 0 };
  }
}

export default new CanvasCursor();
